import {ItemScheduleConfiguration} from "./ItemScheduleConfiguration";

export class ItemPeriodDates {
    constructor(data) {
        const dataExist = data !== null && data !== undefined;
        this.item_schedule_configuration = new ItemScheduleConfiguration(data.item_schedule_configuration)
        this.period_type = dataExist && data.period_type !== undefined ? data.period_type : null;
        this.first_day = dataExist && data.first_day !== undefined ? data.first_day : null;
        this.from_date = dataExist && data.from_date !== undefined ? data.from_date : null;
        this.to_date = dataExist && data.to_date !== undefined ? data.to_date : null;
    }

    setPeriodType(value) {
        this.period_type = value;
    }

    setFromDate(value) {
        this.from_date = value;
    }

    setToDate(value) {
        this.to_date = value;
    }

    setFirstDay(value) {
        this.first_day = value;
    }

    setItemScheduleConfiguration(value) {
        this.item_schedule_configuration = value;
    }

    itemScheduleConfiguration() {
        return this.item_schedule_configuration;
    }

    periodType(){
        return this.period_type
    }

    firstDay(){
        return this.first_day
    }

    fromDate(){
        return this.from_date
    }

    toDate(){
        return this.to_date
    }

    data() {
        const itemScheduleConfiguartionData = this.item_schedule_configuration.data();
        return {
            ...itemScheduleConfiguartionData,
            "from_date": this.fromDate(),
            "to_date": this.toDate(),
            "period_type": this.periodType(),
            "first_day": this.firstDay()
        };
    }

    isSame(otherItemPeriodDates) {
        if (!otherItemPeriodDates) {
            return false;
        }

        if(!this.item_schedule_configuration.isSame(otherItemPeriodDates.itemScheduleConfiguration()))
            return false;

        return this.fromDate() === otherItemPeriodDates.fromDate() &&
            this.toDate() === otherItemPeriodDates.toDate() &&
            this.firstDay() === otherItemPeriodDates.firstDay() &&
            this.periodType() === otherItemPeriodDates.periodType();
    }
}

